module.exports = __webpack_public_path__ + "6a91d38d5e818d3ad66c7c00d2f8096c.png";